<template>
  <div class="header">
    <div class="header-one">
      <div class="brand">
        <!-- <div class="keyWords"
             v-if="postWord">
          <span style="">{{postWord}}</span>
        </div> -->
        <el-tag closable
                v-if="client_id"
                @close="handleClientIdClose"
                class="selectedType">
          客户：{{client_id}}
        </el-tag>
        <el-tag closable
                v-if="postWord && cf_selected_type.length == 0"
                @close="handleWordClose"
                class="keyWords">
          {{$t(selectedType)+postWord}}
        </el-tag>
        <el-tag closable
                v-for="item,index in cf_selected_type"
                :key="item"
                @close="handleCfClose(index)"
                class="keyWords">
          {{transformSelectedType(item) +': '+ cf_word[index]}}
        </el-tag>
        <el-tag closable
                v-if="brandName"
                @close="handleSelectTypeClose"
                class="selectedType cem_hide">
          {{$t('baseInfo.brandLabel')+brandName}}
        </el-tag>

        <el-tag closable
                v-if="KolName"
                @close="handleKolNameClose"
                class="selectedType selectedKol">
          {{$t('baseInfo.kolLabel')+KolName}}
        </el-tag>
        <el-tag closable
                v-if="catName"
                @close="handlecatNameClose"
                class="selectedType cem_hide">
          {{$t('baseInfo.catLabel')+catName}}
        </el-tag>
        <el-tag closable
                v-for="item in scenelist"
                :key="item.id"
                @close="handleScenelistClose(item)"
                class="selectedType">
          {{item.label +'：'}}{{item.name}}{{transformType(item.type)}}
        </el-tag>
        <!-- <div class="edit"
             @click="openDialog">
          <el-tooltip class="item"
                      effect="dark"
                      :content="$t('mainHead.eidtTooltip')"
                      placement="top">
            <i class="el-icon-edit-outline"></i>
          </el-tooltip>
        </div> -->
      </div>
      <div class="
              time-pick">
        <div class="checkBox cem_hide"
             style="margin-right:10px;">
          <div class="labelText"
               style="display:none;margin-right:10px;"> 作者 : </div>
          <el-checkbox-group v-model="authorList"
                             :min="1"
                             @change="handleAuthorChange"
                             style="display:none;">
            <el-checkbox label="consumer">消费者 <el-tooltip class="item"
                          effect="dark"
                          content="粉丝数≤100"
                          placement="top">
                <i class="iconfont icon-Hint"></i>
              </el-tooltip>
            </el-checkbox>
            <el-checkbox label="kol">KOL
              <el-tooltip class="item"
                          effect="dark"
                          content="抖音粉丝数>5w；微博粉丝数>10w；小红书粉丝数>1w"
                          placement="top">
                <i class="iconfont icon-Hint"></i>
              </el-tooltip>
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div>
          <div class="labelText"
               style="display:none;margin-right:10px;"> 平台 : </div>
          <el-checkbox-group v-model="checkList"
                             :min="1"
                             @change="handlePlantChange"
                             style="display:none;">
            <el-checkbox label="weibo">{{$t('mainHead.platList_weibo')}}</el-checkbox>
            <el-checkbox label="douyin">{{$t('mainHead.platList_douyin')}}</el-checkbox>
            <el-checkbox label="xhs">{{$t('mainHead.platList_xhs')}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="timePick"
             style="display:flex;">
          <div class="labelText"
               style="display:inline-block;margin-right:10px;line-height:30px;min-width:36px;"> {{$t('mainHead.dateLabel')}} : </div>
          <!-- <span style="margin:0 6px 0 12px">{{$t('mainHead.dateLabel')}} </span> -->
          <!-- <el-date-picker v-model="startMonth"
                            @change="changeStartMonth"
                            :clearable="false"
                            class="data-pick"
                            size="small"
                            :picker-options="pickerOptions_start"
                            type="month"
                            :placeholder="$t('mainHead.date_holder')">
            </el-date-picker>
            <span style="margin:0 4px">{{$t('mainHead.date_to')}}</span>
            <el-date-picker v-model="endMonth"
                            :clearable="false"
                            @change="changeEndMonth"
                            :picker-options="pickerOptions_end"
                            class="data-pick"
                            size="small"
                            type="month"
                            :placeholder="$t('mainHead.date_holder')">
            </el-date-picker> -->
          <!-- <el-date-picker v-model="dateTime"
                          @change="dateChange"
                          :clearable="false"
                          size="small"
                          style="width:350px;"
                          value-format="yyyy-MM"
                          :picker-options="pickerOptions_start"
                          type="monthrange"
                          range-separator="至"
                          start-placeholder="开始月份"
                          end-placeholder="结束月份">
          </el-date-picker> -->
          <MonthPickers v-model="dateTime"
                        @change="dateChange" />
        </div>
      </div>
    </div>

    <div class="header-two">
      <!-- <div style="width:100%"> -->
      <el-tabs v-model="editableTabsValue"
               type="card"
               @tab-click="handleTabClick">
        <el-tab-pane :key="item.name"
                     v-for="item in editableTabs"
                     :name="item.name">
          <span slot="label">{{item.title}} <i class="el-icon-star-on"
               style="color:#fed141;"
               v-if="item.rule_id&&!item.analyse_typ"></i></span>
        </el-tab-pane>
      </el-tabs>
      <div class="save"
           @click="saveProj"
           v-loading="loading_save">
        <i class="iconfont icon-baocun"></i>
        <el-button style="margin-left:4px;cursor:pointer"
                   type="text">{{$t('mainHead.saveProj')}}</el-button>
      </div>
      <!-- </div> -->
    </div>

    <el-dialog :title="$t('mainHead.eidtTooltip')"
               :visible.sync="dialogVisible"
               width="40%"
               :before-close="handleClose">
      <el-form label-position="left"
               label-width="120px"
               :model="searchForm">

        <el-form-item :label="$t('search.form_category')">
          <!-- <CatSelectTrees ref="catSelectTree"
                          v-model="selectIds"
                          clearable
                          :width="300"
                          @cidChange="cidChange"
                          placeholder-text="选择类目"
                          :checkedKeys="defaultCheckedKeys"
                          @remove-tag="mulltipSelectRemoveTag"
                          @clear="clearSelect"></CatSelectTrees> -->
          <zTree v-model="selectIds"
                 treeDomId="selectZtree3"
                 treeDomSearchId="searchTree3"
                 @clear="clearSelect"
                 @cidChange="cidChange"></zTree>
          <span style="color:#BFBFBF">{{$t('search.form_cat_tip')}}</span>
        </el-form-item>
        <el-form-item :label="$t('search.form_postWord')">
          <el-input v-model="searchForm.KeyWords"
                    size="small"></el-input>
          <span style="color:#BFBFBF">{{$t('search.form_postWord_tip')}}</span>
        </el-form-item>
        <el-form-item :label="$t('search.form_brand')">
          <!-- <el-input v-model="searchForm.brand_name"></el-input> -->
          <el-select v-model="searchForm.brand"
                     filterable
                     clearable
                     remote
                     multiple
                     collapse-tags
                     size="small"
                     :remote-method="remoteMethod"
                     :loading="loading"
                     style="width:100%"
                     :placeholder="$t('search.form_brand_holder')"
                     @change="selectedTypeChange"
                     @remove-tag="handleRemove">
            <el-option v-for="item in brandOptions"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
          <span style="color:#BFBFBF">{{$t('search.form_brand_tip')}}</span>
        </el-form-item>

      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary"
                   @click="search">{{$t('search.searchBtnLab')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBrands } from '@/api/search'
import { saveProj } from '@/api/baseInfo'
import {
  parseTime,
  handelBrandNameOptions,
  getUrlParams,
  getObjFromUrl,
} from '@/utils'
import MonthPickers from '../components/monthPickers/MonthPickers.vue'
import zTree from '@/components/zTree.vue'
import { timeRnage } from '@/mixins/mixins.js'
import { getNav } from '@/api/custom'
import { setUrlParams } from '@/utils'
export default {
  mixins: [timeRnage],
  components: {
    zTree,
    MonthPickers,
  },
  data() {
    return {
      defaultCheckedKeys: [this.$store.state.user.catId],
      selectIds: [this.$store.state.user.catId],
      parseTime: parseTime,
      dialogVisible: false,
      loading: false,
      loading_save: false,
      brandOptions: [],
      searchForm: {
        KeyWords: this.$store.getters.selectedKeyWords,
        selectedType: this.$store.state.user.selectedType,
      },
      editableTabs: [
        {
          title: this.$t('mainHead.tabs_baseInfo'),
          name: 'BaseInfo',
          rule_id: '',
          analyse_typ: '',
        },
        // {
        //   title: this.$t('mainHead.tabs_crowdPortrait'),
        //   name: 'CrowdPortrait',
        //   rule_id: '',
        //   analyse_typ: '',
        // },
        {
          title: this.$t('mainHead.tabs_talents'),
          name: 'TalentList',
          rule_id: '',
          analyse_typ: '',
        },
        {
          title: this.$t('mainHead.tabs_brand'),
          name: 'BrandList',
          rule_id: '',
          analyse_typ: '',
        },
        {
          title: this.$t('mainHead.tabs_custom'),
          name: 'CustomList',
          rule_id: '',
          analyse_typ: '',
        },
      ],
      moreTabs: [],
      postWord: this.$store.state.user.selectedKeyWords,
      selectedType: this.$store.state.user.selectedType,
      brandName:
        this.$store.state.user.brandName &&
        this.$store.state.user.brandName.length
          ? this.$store.state.user.brandName
              .map((item) => {
                return item.name
              })
              .join(' or ')
          : '',
      dateTime: [
        this.$store.state.user.startMonth,
        this.$store.state.user.endMonth,
      ],
      startMonth: this.$store.state.user.startMonth,
      endMonth: this.$store.state.user.endMonth,
      checkList: this.$store.state.user.plants,
      authorList: this.$store.state.user.kolType,
      KolName: this.$store.state.user.KolName,
      catName: this.$store.state.user.catName,
      param_val: getObjFromUrl(window.location.href),
      sceneName: false,
      //   scenelist: [],
      wordsList: this.$store.state.user.words.split(','),
      rulesList: this.$store.state.user.routerRuleId.split(','),
      aspectTypeList: this.$store.state.user.aspectType.split(','),
      authormin: 1,
      catsArr: '',
      client_id: '', //url中的client_id用来展示
    }
  },
  computed: {
    editableTabsValue: {
      get() {
        if (this.$store.state.user.ActivedTab) {
          return this.$store.state.user.ActivedTab
        } else {
          return 'BaseInfo'
        }
      },
      set(val) {
        this.$store.state.user.ActivedTab = val
      },
    },
    scenelist() {
      if (this.editableTabs.length > 4 && this.$store.state.user.words != '') {
        let arrs = []
        let arr = []
        for (let i = 0; i < this.rulesList.length; i++) {
          let obj = this.editableTabs.find(
            (item) => item.rule_id == this.rulesList[i]
          )
          arrs.push(obj.title)
        }
        for (let i = 0; i < this.wordsList.length; i++) {
          arr.push({
            name: this.wordsList[i],
            id: this.rulesList[i],
            type: this.aspectTypeList[i],
            label: arrs[i],
          })
        }
        return arr
      } else {
        return []
      }
    },
    cf_selected_type() {
      return this.$store.state.user.cf_selected_type
    },
    cf_word() {
      return this.$store.state.user.cf_word
    },
  },
  created() {
    this.getNavData()
    if (getUrlParams('client_id')) {
      this.client_id = getUrlParams('client_id')
    }
  },
  methods: {
    transformType(val) {
      if (val == '1') {
        return ''
      } else if (val == '2') {
        return '(正向)'
      } else if (val == '3' || val == '4') {
        return '(负向)'
      } else if (val == '5') {
        return '(中性)'
      }
    },
    transformSelectedType(val) {
      if (val == 'keywords') {
        return this.$t('topHead.select_option_postKeyWords')
      } else if (val == 'customer') {
        return this.$t('topHead.select_option_customer')
      } else if (val == 'seller') {
        return this.$t('topHead.select_option_seller')
      } else if (val == 'company') {
        return this.$t('topHead.select_option_company')
      } else if (val == 'issue') {
        return this.$t('topHead.select_option_work_order')
      } else if (val == 'phone') {
        return this.$t('topHead.select_option_phone')
      }
    },
    dateChange(val) {
      if (val) {
        if (this.startMonth != val[0]) {
          this.startMonth = val[0]
          this.changeStartMonth(val[0])
        }
        if (this.endMonth != val[1]) {
          this.endMonth = val[1]
          this.changeEndMonth(val[1])
        }
      }
    },
    mulltipSelectRemoveTag() {},
    clearSelect() {
      this.selectIds = []
    },
    getNavData() {
      getNav()
        .then((res) => {
          if (res.status == 'ok') {
            let data = res.result.content_analyses
            for (let i = 0; i < data.length; i++) {
              //ner_design source，inside_chat 是否为内部沟通， remark 聊天备注
              if (
                data[i].analyse_typ == 'ner_design' ||
                data[i].analyse_typ == 'inside_chat' ||
                data[i].analyse_typ == 'remark'
              ) {
                this.editableTabs.splice(this.editableTabs.length - 1, 0, {
                  title: data[i].title,
                  name: data[i].analyse_typ,
                  rule_id: data[i].rule_id,
                  analyse_typ: data[i].analyse_typ,
                })
              } else {
                if (data[i].analyse_typ) {
                  this.moreTabs.push({
                    title: data[i].title,
                    name: data[i].analyse_typ,
                    rule_id: data[i].rule_id,
                    analyse_typ: data[i].analyse_typ,
                  })
                } else {
                  //analyse_typ为空的表示是自定义的
                  this.editableTabs.splice(this.editableTabs.length - 1, 0, {
                    title: data[i].title,
                    name: data[i].rule_id,
                    rule_id: data[i].rule_id,
                    analyse_typ: '',
                  })
                }
              }
            }
            for (let i = 0; i < this.moreTabs.length; i++) {
              this.editableTabs.push(this.moreTabs[i])
            }
            this.$store.dispatch('user/changeNavContent', this.editableTabs)
          }
        })
        .finally(() => {})
    },
    cidChange(cats) {
      this.catsArr = cats
      if (cats != '' || cats.length != 0) {
        this.selectIds = [_.last(cats).id]
      }
    },
    selectedTypeChange(val) {},
    handleRemove(key) {},
    openDialog() {
      this.dialogVisible = true
      this.getBrands('', 'name')
    },
    handleClose(done) {
      done()
    },
    search() {
      this.dialogVisible = false
    },
    setSelectedItem(paramVal) {
      if (!paramVal || !paramVal.length) {
        return
      }
      let selectedItems = []
      paramVal.map((item) => {
        let optionItem = {}
        let isExit = this.brandOptions.find((item2) => {
          if (item2.id == item) {
            return item2
          }
        })
        if (isExit) {
          optionItem.id = item
          optionItem.name = isExit.name
          selectedItems.push(optionItem)
        }
      })
      this.$store.dispatch('user/changeBrandName', selectedItems)
    },
    /*
     type:查询类型  id:通过id精确查询，name：通过名称模糊查询
    */
    getBrands(paramVal = [], type = 'id') {
      this.loading = true
      let param = {}
      if (type == 'name') {
        param = { brand_name: paramVal }
      } else {
        param = {
          brand_id: paramVal && paramVal.length ? paramVal.join(',') : '',
        }
      }
      getBrands(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.brandOptions = res.result.data
            this.brandOptions = handelBrandNameOptions(
              this.$store.state.user.selectedType,
              [...this.brandOptions]
            )
            if (
              this.param_val.brand_id &&
              !this.$store.state.user.brandName.length
            ) {
              if (this.brandOptions && this.brandOptions.length) {
                this.setSelectedItem(paramVal)
              }
            }
          }
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.getBrands(query, 'name')
      }
    },
    handleTabClick(tab, event) {
      let item = this.editableTabs.find((item) => {
        return item.name == tab.name
      })
      this.$store.dispatch('user/changeRuleId', item.rule_id)
      this.$store.dispatch('user/changeAnalyseTyp', item.analyse_typ)
      //   localStorage.setItem('passActivedTab', '')
      this.$store.dispatch('user/changeActivedTab', tab.name)
    },
    handleClientIdClose() {
      this.$store.dispatch('user/changeUserId', '')
      this.$store.dispatch('user/changeClientId', '')
      this.$store.dispatch('user/changeSign', '')
      //   this.$store.dispatch('user/changePmId', '')
      //   this.$store.dispatch('user/changeSelectedType', '')
      //   this.$store.dispatch('user/changeselectedKeyWords', '')
      this.client_id = ''
      this.changeTab()
    },
    handleWordClose(e) {
      //   if (this.brandName || this.catName) {
      //     this.$store.dispatch('user/changeselectedKeyWords', '')
      //     this.$store.dispatch('user/changeActivedTab', 'BaseInfo')
      //   } else {
      //     this.$message.warning(this.$t('mainHead.rules_message_search'))
      //   }
      if (this.selectedType == 'issue') {
        this.$store.dispatch('user/changePmId', '')
      }
      this.$store.dispatch('user/changeSelectedType', '')
      this.$store.dispatch('user/changeselectedKeyWords', '')

      this.changeTab()
    },
    handleCfClose(index) {
      let cf_selected_type = _.cloneDeep(
        this.$store.state.user.cf_selected_type
      )
      let cf_word = _.cloneDeep(this.$store.state.user.cf_word)
      if (cf_selected_type[index] == 'issue') {
        this.$store.dispatch('user/changePmId', '')
      }
      cf_selected_type.splice(index, 1)
      cf_word.splice(index, 1)
      this.$store.dispatch('user/changeCfSelectedType', cf_selected_type)
      this.$store.dispatch('user/changeCfWord', cf_word)
      this.$store.dispatch('user/changeSelectedType', '')
      this.$store.dispatch('user/changeselectedKeyWords', '')
    },
    changeTab() {
      if (this.$store.state.user.ruleId) {
        let ruleId = this.$store.state.user.ruleId
        let obj = _.find(this.editableTabs, function (o) {
          return o.rule_id == ruleId
        })
        if (obj && obj.analyse_typ == '') {
          this.$store.dispatch('user/changeActivedTab', obj.rule_id)
        } else {
          this.$store.dispatch('user/changeActivedTab', 'BaseInfo')
        }
      } else {
        this.$store.dispatch('user/changeActivedTab', 'BaseInfo')
      }
    },
    handlecatNameClose(e) {
      //   if (this.postWord || this.brandName) {
      //     this.catName = ''
      //     this.$store.dispatch('user/changeCatName', '')
      //     this.$store.dispatch('user/changeCatId', '')
      //     this.$store.dispatch('user/changeActivedTab', 'BaseInfo')
      //   } else {
      //     this.$message.warning(this.$t('mainHead.rules_message_search'))
      //   }
      this.catName = ''
      this.$store.dispatch('user/changeCatName', '')
      this.$store.dispatch('user/changeCatId', '')
      this.changeTab()
    },
    handleScenelistClose(item) {
      let arr = this.$store.state.user.routerRuleId.split(',')
      let arr2 = this.$store.state.user.words.split(',')
      let arr3 = this.$store.state.user.routerAnalyseTyp.split(',')
      let arr4 = this.$store.state.user.aspectType.split(',')
      let arr5 = this.$store.state.user.labelLevel.split(',')
      let arr6 = this.$store.state.user.issue_id.split('-')
      let index = _.findIndex(arr, function (o) {
        return o == item.id
      })
      if (index != -1) {
        arr.splice(index, 1)
        arr2.splice(index, 1)
        arr3.splice(index, 1)
        arr4.splice(index, 1)
        arr5.splice(index, 1)
        arr6.splice(index, 1)
        this.$store.dispatch('user/changeRouterRuleId', arr.join(','))
        this.$store.dispatch('user/changeWords', arr2.join(','))
        this.$store.dispatch('user/changeRouterAnalyseTyp', arr3.join(','))
        this.$store.dispatch('user/changeAspectType', arr4.join(','))
        this.$store.dispatch('user/changeLabelLevel', arr5.join(','))
        this.$store.dispatch('user/changeIssueId', arr6.join('-'))
        this.changeTab()
      }
    },
    handleSelectTypeClose(e) {},
    handleKolNameClose(e) {
      this.$store.dispatch('user/changeKolId', '')
      this.$store.dispatch('user/changeKolName', '')
      localStorage.setItem('kol_name', '')
      this.changeTab()
    },
    changeStartMonth(val) {
      if (!val) {
        this.$message.warning(this.$t('mainHead.rules_message_range'))
        this.startMonth = this.$store.state.user.startMonth
        return
      }
      this.$store.dispatch('user/changeStartMonth', this.startMonth)
    },
    changeEndMonth(val) {
      if (!val) {
        this.$message.warning(this.$t('mainHead.rules_message_range'))
        this.endMonth = this.$store.state.user.endMonth
        return
      }
      this.$store.dispatch('user/changeEndMonth', this.endMonth)
    },
    handleAuthorChange() {
      this.$store.dispatch('user/changeKolType', this.authorList)
    },
    handlePlantChange() {
      this.$store.dispatch('user/changeplants', this.checkList)
    },
    saveProj() {
      this.loading_save = true
      let param = {}
      param.plat = this.$store.state.user.plants
        ? this.$store.state.user.plants.join(',')
        : ''
      // param.brand_name = _.map(this.$store.state.user.brandName, 'name').join(
      //   ','
      // )
      // param.brand_id =
      //   this.$store.state.user.selectedType &&
      //   this.$store.state.user.selectedType.length
      //     ? this.$store.state.user.selectedType.join(',')
      //     : ''
      param.selected_type = this.$store.state.user.selectedType
      param.cat_id = this.$store.state.user.catId
      param.cat_name = this.$store.state.user.catName
      param.kol_id = this.$store.state.user.KolId
      param.kol_name = this.$store.state.user.KolName
      param.word = this.$store.state.user.selectedKeyWords
      param.start = parseTime(this.$store.state.user.startMonth, '{y}-{m}-{d}')
      param.end = parseTime(this.$store.state.user.endMonth, '{y}-{m}-{d}')
      param.func = 'ADD'
      saveProj(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.$message.success(this.$t('mainHead.message_saveProj_success'))
          } else {
            this.$message.error(this.$t('mainHead.message_saveProj_failed'))
          }
          this.loading_save = false
        })
        .catch((e) => {
          this.loading_save = false
        })
        .finally(() => {
          this.loading_save = false
        })
    },
  },
  watch: {
    '$store.state.user.plants': {
      handler(newVal, oldVal) {
        this.checkList = newVal
      },
    },
    '$store.state.user.kolType': {
      handler(newVal, oldVal) {
        this.authorList = newVal
      },
    },

    '$store.state.user.startMonth': {
      handler(newVal, oldVal) {
        this.startMonth = newVal
        this.dateTime = [newVal, this.dateTime[1]]
      },
    },

    '$store.state.user.endMonth': {
      handler(newVal, oldVal) {
        this.endMonth = newVal
        this.dateTime = [this.dateTime[0], newVal]
      },
    },
    '$store.state.user.selectedKeyWords': {
      handler(newVal, oldVal) {
        this.searchForm.KeyWords = newVal
        this.postWord = newVal
      },
    },
    '$store.state.user.catName': {
      handler(newVal, oldVal) {
        this.catName = newVal
      },
    },
    '$store.state.user.selectedType': {
      handler(newVal, oldVal) {
        this.selectedType = newVal
        // this.searchForm.brand = newVal
        // this.brandName = localStorage.getItem('brandName')
        // this.brandName =
        //   this.$store.state.user.brandName &&
        //   this.$store.state.user.brandName.length
        //     ? this.$store.state.user.brandName
        //         .map((item) => {
        //           return item.name
        //         })
        //         .join(' or ')
        //     : ''
        // this.brandOptions = handelBrandNameOptions(newVal, [
        //   ...this.brandOptions,
        // ])
      },
      immediate: true,
    },
    '$store.state.user.brandName': {
      handler(newVal, oldVal) {
        let name = newVal.length
          ? newVal
              .map((item) => {
                return item.name
              })
              .join(' or ')
          : ''
        this.$set(this, 'brandName', name)
      },
    },
    '$store.state.user.KolName': {
      handler(newVal, oldVal) {
        this.$set(this, 'KolName', newVal)
      },
    },
    '$store.state.user.words': {
      handler(newVal, oldVal) {
        let arr = newVal.split(',')
        this.$set(this, 'wordsList', arr)
        let arrs = this.$store.state.user.routerRuleId.split(',')
        this.$set(this, 'rulesList', arrs)
      },
    },
    '$store.state.user.routerRuleId': {
      handler(newVal, oldVal) {
        let arr = newVal.split(',')
        this.$set(this, 'rulesList', arr)
      },
    },
    '$store.state.user.aspectType': {
      handler(newVal, oldVal) {
        let arr = newVal.split(',')
        this.$set(this, 'aspectTypeList', arr)
      },
    },
    '$store.state.user.client_id': {
      handler(newVal, oldVal) {
        this.client_id = newVal
      },
    },
  },
}
</script>

<style lang="less" scoped>
.timePick {
  /deep/ .el-date-editor .el-range-separator {
    width: 7%;
  }
}
</style>